import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'
import { ThemeProvider, CssBaseline } from '@mui/material'
import { ROUTES } from './common/constant'
import { theme } from './common/theme'
import { AuthProvider } from './common/contexts/AuthContext'
import ProtectedRoute from './components/ProtectedRoute'
import Dashboard from './pages/Dashboard'
import PatientList from './pages/PatientList'
import PatientDetail from './pages/PatientDetail'
import PatientCreate from './pages/PatientCreate'
import ScheduleDetail from './pages/ScheduleDetail'
import Jobs from './pages/Jobs'
import Settings from './pages/Settings'
import Login from './pages/Login'
import Layout from './components/Layout'

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AuthProvider>
        <Router>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <Layout />
                </ProtectedRoute>
              }
            >
              <Route index element={<Dashboard />} />
              <Route path={ROUTES.PATIENTS} element={<PatientList />} />
              <Route path={ROUTES.PATIENT_CREATE} element={<PatientCreate />} />
              <Route path={ROUTES.PATIENT_DETAIL} element={<PatientDetail />} />
              <Route path={ROUTES.SCHEDULE_DETAIL} element={<ScheduleDetail />} />
              <Route path={ROUTES.JOBS} element={<Jobs />} />
              <Route path={ROUTES.SETTINGS} element={<Settings />} />
            </Route>
          </Routes>
        </Router>
      </AuthProvider>
    </ThemeProvider>
  )
}

export default App
